// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--2Fxn6";
export var hero_bg = "styles-module--hero_bg--1bWc_";
export var hero_inner = "styles-module--hero_inner--2Uw_T";
export var jsAnimInit = "styles-module--jsAnimInit--1Sf_0";
export var hero_list = "styles-module--hero_list--1V0pk";
export var hero_center = "styles-module--hero_center--oXxSa";
export var hero_top = "styles-module--hero_top--1GqFF";
export var hero_bot = "styles-module--hero_bot--1OoFT";
export var hero_title = "styles-module--hero_title--2KTGe";